import { render, staticRenderFns } from "./IntervalTable.vue?vue&type=template&id=c0274df8"
import script from "./IntervalTable.vue?vue&type=script&lang=js"
export * from "./IntervalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports